import CbPileVariabilityData from './CbPileVariabilityData';
import CbPileVariabilityVideos from './CbPileVariabilityVideos';

export default function CbPileVariability({ projectKey }) {
    return (
        <>
            <CbPileVariabilityVideos projectKey={projectKey} />
            <CbPileVariabilityData projectKey={projectKey} />
        </>
    );
}
